export default {
      id: "xtype_xcool-usage",
      viewBox: "0 0 28 14",
      url: __webpack_public_path__ + "img/icons.svg#xtype_xcool",
      toString: function () {
        return this.url;
      }
    }